import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { allReducers } from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [],
};

const rootReducer: any = combineReducers(allReducers);

export type RootState = ReturnType<typeof rootReducer>;

export default persistReducer(persistConfig, rootReducer);
